/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const BlogCreatePage = lazyLoad(
  () => import('./index'),
  module => module.BlogCreatePage
);
